module.exports = __webpack_public_path__ + "img/mobile-34.f17143ba.png";